import React, { useEffect } from "react";
import Header from "~/assets/js/components/Header";
import {
    FAQs,
    Banner,
    ProductCategories,
    AboutUs,
    Highlights,
    USPs,
    Promo,
} from "./sections";
import { viewPage } from "~/assets/js/Api/eventsApi";

const Home = () => {
    useEffect(() => {
        setTimeout(() => viewPage(document.title), 500);
    }, []);

    return (
        <main id="homepage">
            <div className="gc-window">
                <iframe src="https://green.club"></iframe>
            </div>
        </main>
    );
};

const HomePage = () => (
    <>
        <Header />
        <Home />
    </>
);

export default HomePage;
